<template>
	<modal
		class="customize-columns-modal"
		size="medium"
		@close="close"
	>
		<template slot="header">
			<div class="flex-center">
				<h3>{{ action }} As Dangerous Goods</h3>
			</div>
		</template>
		<div slot="body">
			Are you sure want to {{ action }} <b>{{ productName }}</b> as <span class="text-danger">Dangerous Goods</span>?
		</div>
		<div slot="footer">
			<button
				class="btn btn-light"
				@click="close"
			>
				Close
			</button>
			<button
				class="btn btn-primary"
				:class="{ 'is-loading': isSaving }"
				@click="apply"
			>
				Apply
			</button>
		</div>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
	name: 'ModalConfirmDangerousGoods',
	components: {
		Modal,
	},
	props: {
		isSaving: {
			type: Boolean,
			default: false,
		},
		productName: {
			type: String,
			default: '',
		},
		action: {
			type: String,
			default: '',
		},
	},
	methods: {
		close() {
			this.$emit('close');
		},
		apply() {
			this.$emit('apply');
		},
	},
};
</script>
